import { type ApprovedExpenseItem } from '@webapp/modules/expense/entities/ApprovedExpenseItem'
import { useCorrectExpenseItemAccountCodesPresenter } from './useCorrectExpenseItemAccountCodesPresenter'
import { CorrectExpenseItemAccountCodesForm } from '../../views/CorrectExpenseItemAccountCodesForm'

export interface ICorrectExpenseItemAccountCodesPresenterProps {
  item: ApprovedExpenseItem
  onSuccess: () => void
  onCancel: () => void
}

/**
 * Presenter for the "Edit approved item" correction form content. Renders
 * form content only — the Feature Set owns the Modal chrome.
 */
export const CorrectExpenseItemAccountCodesPresenter = ({
  item,
  onSuccess,
  onCancel,
}: ICorrectExpenseItemAccountCodesPresenterProps) => {
  const {
    data: { siblings, budgetPeriodsByItemId, currencyCode },
    states: {
      isLoadingSiblings,
      isSaving,
      showBudgetDate,
      showApplyToAllAccount,
    },
    handlers: { handleSubmit, handleAccountSelected, resolveAttachmentUrl },
  } = useCorrectExpenseItemAccountCodesPresenter({ item, onSuccess })

  return (
    <CorrectExpenseItemAccountCodesForm
      item={item}
      siblings={siblings}
      budgetPeriodsByItemId={budgetPeriodsByItemId}
      isLoadingSiblings={isLoadingSiblings}
      isSaving={isSaving}
      showBudgetDate={showBudgetDate}
      showApplyToAllAccount={showApplyToAllAccount}
      currencyCode={currencyCode}
      resolveAttachmentUrl={resolveAttachmentUrl}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      onAccountSelected={handleAccountSelected}
    />
  )
}

CorrectExpenseItemAccountCodesPresenter.displayName =
  'CorrectExpenseItemAccountCodesPresenter'
